module.exports = __webpack_public_path__ + "d52d5118476fe342990a90480e25397a.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/wechat-active.png
 ** module id = 1556
 ** module chunks = 0
 **/